var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle164ASelected = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 142 48",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.793 3.274A2.5 2.5 0 0 1 20.283 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.545 6A2.5 2.5 0 0 1 26.262 12h-6.524a2.5 2.5 0 0 1-2.49-2.726l.545-6Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M19.738 2c-.686 0-1.314.388-1.62 1.002l-.223.445a1 1 0 1 1-1.79-.894l.223-.446A3.813 3.813 0 0 1 19.738 0h6.524c1.444 0 2.764.816 3.41 2.107l.223.446a1 1 0 1 1-1.79.894l-.222-.445A1.812 1.812 0 0 0 26.262 2h-6.524Z",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M17.793 44.726A2.5 2.5 0 0 0 20.283 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.545-6A2.5 2.5 0 0 0 26.262 36h-6.524a2.5 2.5 0 0 0-2.49 2.726l.545 6Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M19.738 46a1.812 1.812 0 0 1-1.62-1.002l-.223-.445a1 1 0 1 0-1.79.894l.223.445A3.813 3.813 0 0 0 19.738 48h6.524a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 1 0-1.79-.894l-.222.445A1.812 1.812 0 0 1 26.262 46h-6.524Z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M33.792 3.274A2.5 2.5 0 0 1 36.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 42.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M35.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 35.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 42.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M33.792 44.726A2.5 2.5 0 0 0 36.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 42.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M35.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 35.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 42.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.792 3.274A2.5 2.5 0 0 1 52.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 58.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M51.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 51.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 58.26 2h-6.524Z",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M49.792 44.726A2.5 2.5 0 0 0 52.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 58.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M51.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 51.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 58.26 46h-6.524Z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M65.792 3.274A2.5 2.5 0 0 1 68.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 74.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M67.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 67.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 74.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M65.792 44.726A2.5 2.5 0 0 0 68.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 74.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M67.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 67.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 74.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M81.792 3.274A2.5 2.5 0 0 1 84.282 1h5.433a2.5 2.5 0 0 1 2.49 2.274l.546 6A2.5 2.5 0 0 1 90.26 12h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M83.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 83.737 0h6.523c1.445 0 2.765.816 3.41 2.107l.223.446a1 1 0 0 1-1.789.894l-.222-.445A1.812 1.812 0 0 0 90.26 2h-6.523Z",
  clipRule: "evenodd"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M81.792 44.726A2.5 2.5 0 0 0 84.282 47h5.433a2.5 2.5 0 0 0 2.49-2.274l.546-6A2.5 2.5 0 0 0 90.26 36h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M83.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 83.737 48h6.523a3.812 3.812 0 0 0 3.41-2.108l.223-.445a1 1 0 0 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 90.26 46h-6.523Z",
  clipRule: "evenodd"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M3.274 29.207A2.5 2.5 0 0 1 1 26.717v-5.433a2.5 2.5 0 0 1 2.274-2.49l6-.546A2.5 2.5 0 0 1 12 20.738v6.525a2.5 2.5 0 0 1-2.726 2.49l-6-.546Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M2 27.262c0 .687.388 1.314 1.002 1.621l.445.223a1 1 0 0 1-.894 1.789l-.446-.223A3.813 3.813 0 0 1 0 27.262v-6.524c0-1.444.816-2.764 2.107-3.41l.446-.222a1 1 0 0 1 .894 1.789l-.445.222A1.813 1.813 0 0 0 2 20.738v6.524Z",
  clipRule: "evenodd"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M13.998 16.5c0-1.38 1.994-2.5 4.454-2.5h105.093c2.46 0 4.454 1.12 4.454 2.5v15c0 1.38-1.994 2.5-4.454 2.5H18.452c-2.46 0-4.454-1.12-4.454-2.5v-15ZM138.725 18.793a2.5 2.5 0 0 1 2.274 2.49v5.434a2.5 2.5 0 0 1-2.274 2.49l-6 .545a2.5 2.5 0 0 1-2.726-2.49v-6.524a2.5 2.5 0 0 1 2.726-2.49l6 .545Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M139.999 20.738c0-.686-.388-1.314-1.002-1.62l-.446-.223a1 1 0 1 1 .895-1.79l.445.223a3.812 3.812 0 0 1 2.108 3.41v6.524a3.812 3.812 0 0 1-2.108 3.41l-.445.223a1 1 0 0 1-.895-1.79l.446-.222a1.813 1.813 0 0 0 1.002-1.621v-6.524Z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M97.792 3.274A2.5 2.5 0 0 1 100.28 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M99.737 2c-.686 0-1.314.388-1.621 1.002l-.223.445a1 1 0 0 1-1.789-.894l.223-.446A3.812 3.812 0 0 1 99.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 106.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M97.792 44.726A2.5 2.5 0 0 0 100.28 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M99.737 46a1.813 1.813 0 0 1-1.621-1.002l-.223-.445a1 1 0 0 0-1.789.894l.223.445A3.812 3.812 0 0 0 99.737 48h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 106.261 46h-6.524Z",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M113.792 3.274A2.5 2.5 0 0 1 116.281 1h5.434a2.5 2.5 0 0 1 2.49 2.274l.546 6a2.5 2.5 0 0 1-2.49 2.726h-6.525a2.5 2.5 0 0 1-2.49-2.726l.546-6Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M115.737 2c-.687 0-1.314.388-1.621 1.002l-.223.445a1 1 0 1 1-1.789-.894l.223-.446A3.813 3.813 0 0 1 115.737 0h6.524c1.444 0 2.764.816 3.41 2.107l.222.446a1 1 0 1 1-1.789.894l-.222-.445A1.813 1.813 0 0 0 122.261 2h-6.524Z",
  clipRule: "evenodd"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M113.792 44.726A2.5 2.5 0 0 0 116.281 47h5.434a2.5 2.5 0 0 0 2.49-2.274l.546-6a2.5 2.5 0 0 0-2.49-2.726h-6.525a2.5 2.5 0 0 0-2.49 2.726l.546 6Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#C1A36E",
  fillRule: "evenodd",
  d: "M115.737 46a1.812 1.812 0 0 1-1.621-1.002l-.223-.445a1 1 0 1 0-1.789.894l.223.445a3.813 3.813 0 0 0 3.41 2.108h6.524a3.813 3.813 0 0 0 3.41-2.108l.222-.445a1 1 0 1 0-1.789-.894l-.222.445A1.813 1.813 0 0 1 122.261 46h-6.524Z",
  clipRule: "evenodd"
})));
SvgRectangle164ASelected.viewBox = '0 0 142 48';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle164ASelected);
export default ForwardRef;